/** Requests to the managing company (spec §6.7; v1 RequestDialog). */

export const RequestType = { Join: 1, Pass: 2, Confidance: 3, Message: 4 } as const;
export const RequestStatus = { Pending: 1, Accepted: 2, Rejected: 3 } as const;

export interface RequestItem {
  id: number;
  /** Server-made: "Разовый пропуск", "Доверенное лицо", or the literal "Тема запроса" for types 1 and 4. */
  title: string;
  description: string;
  type: number;
  status: number;
  objectId: number;
  requestData: Record<string, unknown> & { title?: string; message?: string; address?: string; addressName?: string };
  refuseReason: string | null;
}

const KIND: Record<number, string> = {
  [RequestType.Join]: 'Присоединение к объекту',
  [RequestType.Pass]: 'Пропуск на согласование',
  [RequestType.Confidance]: 'Доверенность',
  [RequestType.Message]: 'Сообщение в УК',
};

const STATUS: Record<number, string> = {
  [RequestStatus.Pending]: 'На рассмотрении',
  [RequestStatus.Accepted]: 'Принята',
  [RequestStatus.Rejected]: 'Отклонена',
};

export interface RequestView {
  kind: string;
  title: string;
  subtitle: string;
  status: string;
  reason: string | null;
  /** Messages can be sent only while the request is under review (REQUEST_IS_CLOSED otherwise). */
  open: boolean;
}

export function describeRequest(r: RequestItem): RequestView {
  const d = r.requestData ?? {};
  let title: string;
  let subtitle = '';
  switch (r.type) {
    case RequestType.Message:
      title = d.title || 'Сообщение';
      subtitle = d.message ?? '';
      break;
    case RequestType.Join:
      title = d.address || 'Заявка на присоединение';
      break;
    case RequestType.Pass:
      title = r.description;
      subtitle = [r.title, d.addressName].filter(Boolean).join(' · ');
      break;
    default:
      title = r.description || r.title;
  }
  return {
    kind: KIND[r.type] ?? 'Обращение',
    title,
    subtitle,
    status: STATUS[r.status] ?? '—',
    reason: r.status === RequestStatus.Rejected ? r.refuseReason : null,
    open: r.status === RequestStatus.Pending,
  };
}

const GROUPS = [
  { status: RequestStatus.Pending, label: 'На рассмотрении' },
  { status: RequestStatus.Accepted, label: 'Приняты' },
  { status: RequestStatus.Rejected, label: 'Отклонены' },
];

/** Under review first, then accepted, then rejected (spec §6.7). Empty groups are dropped. */
export function groupRequests(items: readonly RequestItem[]) {
  return GROUPS.map((g) => ({ label: g.label, items: items.filter((i) => i.status === g.status) })).filter((g) => g.items.length);
}
